import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const {
  INPUT,
  DATE,
  SELECT,
  TEXT_AREA,
  TIME,
  NUMBER,
  CURRENCY,
  AUTO_COMPLETE,
  COMBO_BOX,
} = FIELD_TYPE;
const cssProps = {
  labelCol: { xs: 4, sm: 10, md: 5, xl: 5 },
  wrapperCol: { xs: 20, sm: 24, md: 24, xl: 24 },
  css: { xs: 24, xl: 12, md: 24, sm: 24 },
};
const TEL_NUMBER_REGEX = /^\d+$/;

const validatePhoneNumber = (rule, value) => {
  if (!TEL_NUMBER_REGEX.test(value)) {
    return Promise.reject("Chỉ cho phép nhập số");
  } else if (value.length > 11) {
    return Promise.reject("Số điện thoại tối đa 11 chữ số");
  } else if (value.length < 10) {
    return Promise.reject("Số điện thoại tối thiểu 10 chữ số");
  } else {
    return Promise.resolve();
  }
};
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
const columnsTable: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    render: (value, record, index) => index + 1,
    show: true,
    align: "center",
  },
  {
     type: "INPUT",
    dataIndex: "hoTenNguoiLienHe",
    key: "hoTenNguoiLienHe",
    title: "Họ tên",
    align: "center",
    show: true,
    height:70,
    disable:"false"
  },
  {
     type: "COMBO_BOX",
    dataIndex: "quanHeVoiCBNV",
    key: "quanHeVoiCBNV",
    title: "Quan hệ với CBCNV",
    align: "center",
    show: true,
    height:70,
    disable:"false",
    options:[
    { value: "Bố", label: "Bố" },
    { value: "Mẹ", label: "Mẹ" },
    { value: "Vợ", label: "Vợ" },
    { value: "Chồng", label: "Chồng" },
    { value: "Khác", label: "Khác" },
  ]
  },
  {
     type: "INPUT",
    dataIndex: "soDienThoaiNguoiQuanHe",
    key: "soDienThoaiNguoiQuanHe",
    title: "Số điện thoại liên hệ",
    align: "center",
    show: true,
    height:70,
    disable:"false",
    rules: [
      {
        validator: validatePhoneNumber,
        required: false,
      },
    ],
  },
  {
    title: "",
    dataIndex: "action",
    key: "action",
    align: "center",
    fixed: "right" as any,
    show: true,
    disable:"false"
  },
];

export default columnsTable;
